import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { init } from '@store/index.js';
import Routes from '@pages/Routes/index.js';
import ReactGA from 'react-ga';
import { Helmet } from 'react-helmet';

const Root = (props) => {
  useEffect(() => {
    ReactGA.initialize('UA-128505641-3');
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  const store = init(props.reducers);

  return (
    <Provider store={store}>
      <Helmet>
        <script>
          {`
            (function(h,o,t,j,a,r){
                h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                h._hjSettings={hjid:1896683,hjsv:6};
                a=o.getElementsByTagName('head')[0];
                r=o.createElement('script');r.async=1;
                r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                a.appendChild(r);
            })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
          `}
        </script>
      </Helmet>

      <BrowserRouter>
        <Routes />
      </BrowserRouter>
    </Provider>
  );
};

export default Root;
